export default __webpack_public_path__ + "static/media/maps-and-flags.7d919583.svg";